/* 🤖 this file was generated by script */
export const wiconApprovePathRemove = {
  name: 'approve_path_remove',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 10a2 2 0 11-4 0 2 2 0 014 0zm0 0h3m3 0h2m0 0a1 1 0 112 0 1 1 0 01-2 0zM2 2l16 16"/></svg>`,
};
